import { render } from "./BTCell.vue?vue&type=template&id=65bca29d&scoped=true"
import script from "./BTCell.vue?vue&type=script&lang=js"
export * from "./BTCell.vue?vue&type=script&lang=js"

import "./BTCell.vue?vue&type=style&index=0&id=65bca29d&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bca29d"]])

export default __exports__